import styled from 'styled-components';

export default styled.div`
  background: #f3f3f3;
  padding: 25px;
  height: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`;
